/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S1_HeadingInputs */

const tr_iletisim_s1_heading = /** @type {(inputs: Iletisim_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı mesaj gönder`)
};

const en_iletisim_s1_heading = /** @type {(inputs: Iletisim_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a quick message`)
};

const de_iletisim_s1_heading = /** @type {(inputs: Iletisim_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnell eine Nachricht senden`)
};

const ru_iletisim_s1_heading = /** @type {(inputs: Iletisim_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить быстрое сообщение`)
};

/**
* | output |
* | --- |
* | "Send a quick message" |
*
* @param {Iletisim_S1_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s1_heading = /** @type {((inputs?: Iletisim_S1_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S1_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s1_heading(inputs)
	if (locale === "de") return de_iletisim_s1_heading(inputs)
	if (locale === "ru") return ru_iletisim_s1_heading(inputs)
	return tr_iletisim_s1_heading(inputs)
});